<template>
  <div v-if="isDev" class="dev-panel">
    <v-btn icon="settings" @click="togglePanel" variant="plain" color="text-primary"> </v-btn>

    <v-overlay v-model="isPanelOpen" class="dev-overlay">
      <v-card class="dev-card">
        <v-btn @click="togglePanel" class="close" icon="close" color="text-primary" variant="text" density="compact" />
        <v-card-title>Developer Tools</v-card-title>
        <v-alert v-if="error" type="error" class="mb-4">{{ $t(`errors.${error}`) }}</v-alert>
        <v-card-actions>
          <v-btn color="error" @click="resetStore"> Reset Store </v-btn>
          <v-btn color="success" :loading="isCreating" :disabled="isCreating" @click="createFakeAccount">
            Create Test Account
          </v-btn>
          <v-btn color="on-surface" @click="togglePanel"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import { useStore } from '@/store';
import { v4 as uuidv4 } from 'uuid';

export default defineComponent({
  name: 'DevPanel',
  setup() {
    const store = useStore();
    const isPanelOpen = ref(false);
    const isCreating = ref(false);
    const error = ref('');
    const isDev = computed(() => process.env.NODE_ENV === 'development');

    const togglePanel = () => {
      isPanelOpen.value = !isPanelOpen.value;
    };

    const resetStore = () => {
      store.commit('clearUserProfile');
    };

    const createFakeAccount = async () => {
      if (isCreating.value) return;
      isCreating.value = true;
      error.value = '';
      try {
        const id = uuidv4();
        const user = await store.dispatch('registerUser', {
          login: `testuser_${id}`,
          email: `test_${id}@example.com`,
          password: uuidv4(),
          name: `test_${id.slice(0, 8)}`,
        });
        if ('error' in user) {
          error.value = user.error;
        } else {
          isPanelOpen.value = false;
        }
      } catch {
        error.value = 'requestFailed';
      } finally {
        isCreating.value = false;
      }
    };

    return {
      isDev,
      isPanelOpen,
      isCreating,
      error,
      togglePanel,
      resetStore,
      createFakeAccount,
    };
  },
});
</script>

<style scoped>
.close {
  position: absolute;
  width: auto !important;
  top: 8px;
  right: 8px;
  z-index: 10;
}

.dev-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dev-card {
  padding: 24px;
  min-width: 350px;
  border-radius: 12px;
}

.dev-card .v-card-title {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 16px;
}

.dev-card .v-card-actions {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0;
}

.dev-card .v-btn {
  width: 100%;
  height: 48px;
}
</style>
